/** Links into the Resource editor, kept apart from its page so the router and
 * the workspace host can build them without loading the stages. */
import type { ResourceEditorLocation, ResourceEditorSlot } from './useResourceEditor';

/** `/coach/resources/new?kind=…` or `/coach/resources/$id?entry=…`, one route. */
export function resourceEditorHref(location:ResourceEditorLocation, replace = false) {
  return location.mode === 'new'
    ? { to:'/coach/resources/$resourceId' as const, params:{ resourceId:'new' }, replace,
      search:{ kind:location.kind, match_id:location.matchId, slot:location.slot, entry:location.entry } }
    : { to:'/coach/resources/$resourceId' as const, params:{ resourceId:location.resourceId }, replace,
      search:{ entry:location.entry, revision:location.revision } };
}

const SLOTS:ResourceEditorSlot[] = ['full', 'first_half', 'second_half', 'extra_time', 'penalty_shootout'];
/** Where a plain `/coach/review` visit opens in canonical builds (plan PR 3):
 * the board editor, the moment editor on the requested match and recording,
 * else the kind chooser. `player_id` and `compose` only seeded the legacy
 * composer, so they are dropped. */
export function coachReviewRedirect(search:{ source?:'video' | 'tactical_board'; match_id?:string; slot?:string }) {
  const to = '/coach/resources/$resourceId' as const, params = { resourceId:'new' };
  if (search.source === 'tactical_board') return { to, params, search:{ kind:'tactical_board' as const } };
  if (search.match_id) return { to, params, search:{ kind:'moment' as const, match_id:search.match_id,
    slot:SLOTS.find(slot => slot === search.slot) } };
  return { to, params, search:{} };
}
